export const CARGANDO = 'CARGANDO';
export const INACTIVO = 'INACTIVO';
export const ACTIVO = 'ACTIVO';
export const FILTRADO = 'FILTRADO';
export const ERROR = 'ERROR';
